export interface IClaim {
  Type: string;
  Value: string;
  Issuer: string;
  OriginalIssuer: string;
  Properties: unknown;
  Subject: unknown;
  ValueType: string;
}

export class ClaimModel implements Pick<IClaim, 'Value' | 'Type'> {
  Type: string;
  Value: string;

  constructor(data: IClaim) {
    this.Type = data.Type ?? data.Type;
    this.Value = data.Value ?? data.Value;
  }
}
